import { Button as RadixButton } from "@radix-ui/themes";
import styled from "@emotion/styled";

export const BaseButton = styled(RadixButton)`
  background-color: rgb(255, 255, 255);
  padding: 1.4px 7px 0px 7px;
  margin: 0;
  border-radius: 0;
  outline: none !important;

  &:hover {
    background-color: rgb(230, 230, 230);
  }

  &:active {
    background-color: rgb(220, 220, 220);
  }
`;
